import { tenants, type Tenant, type TenantId } from './tenants'
import { parseTenantHosts, type RuntimeConfig } from './runtime'

function isTenantId(value: string): value is TenantId {
  return value in tenants
}

/* Tenant resolution: hostname -> tenant id via the runtime host map, falling
   back to the configured default (covers localhost and unknown hosts).
   Multi-tenant later (PLCC on partner.plcc-gmbh.de) is: add the tenant in
   tenants.ts + themes.css, then extend TENANT_HOSTS env - no code change. */
export function resolveTenant(hostname: string, config: RuntimeConfig): Tenant {
  const map = parseTenantHosts(config.tenantHosts ?? '')
  const mapped = map[hostname.toLowerCase()] ?? config.defaultTenant
  if (isTenantId(mapped)) return tenants[mapped]
  if (isTenantId(config.defaultTenant)) return tenants[config.defaultTenant]
  throw new Error(`Unknown tenant "${mapped}" and invalid defaultTenant "${config.defaultTenant}"`)
}
